import { render, staticRenderFns } from "./ForwardHistory.vue?vue&type=template&id=0be8d27a"
import script from "./ForwardHistory.vue?vue&type=script&lang=js"
export * from "./ForwardHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports